import React, {useEffect, useState} from 'react';
import {
  ActivityIndicator,
  ScrollView,
  StyleSheet,
  Text,
  View,
  Dimensions,
} from 'react-native';
import {Card} from 'react-native-elements';
import HomeHeader from '../../components/HomeHeader';
import {FaEdit} from 'react-icons/fa';
import {
  storeAccountId,
  storeBrandId,
  storeOperatorId,
} from '../../database/DataBase';
import {getProfileInfo} from '../../network/Network';
import {toast} from 'react-toastify';
import Loading from '../../components/Loading';

const HEIGHT = Dimensions.get('window').height;
const WIDTH = Dimensions.get('window').width;

export function InfoBar(props) {
  return (
    <Card containerStyle={styles.cardContainerStyle}>
      <Text style={styles.infoTextHeaderStyle}>{props.title}</Text>
      <Text style={styles.infoTextStyle}>{props.info}</Text>
    </Card>
  );
}

export default function ProfileScreen(props) {

  const [profileData, setProfileData] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getProfileInfo(true)
      .then((reply) => {
        if (reply.success && (reply.status === 200 || reply.status === 201)) {
          setProfileData(reply);
          setIsLoading(false);
          storeAccountId(reply.data.accounts[0].id);
          storeBrandId(reply.data.accounts[0].brand_id);
          storeOperatorId(reply.data.profile.sublocation_details.operator_id);
        }
      })
      .catch((r) => {
        console.log(r);
        toast('Error, please try again');
      });
  }, []);

  const onEditPress = () => {
    props.navigation.push('ProfileEdit');
  };

  return (
    <View style={styles.viewStyle}>
      <HomeHeader navigation={props.navigation} />
      {isLoading ? (
        <View style={styles.indicatorViewStyle}>
          <Loading />
        </View>
      ) : (
        <View style={{backgroundColor: '#1a191f'}}>
          <ScrollView
            contentContainerStyle={styles.scrollViewContainerStyle}
            style={styles.scrollViewStyle}>
            <InfoBar
              title={'User Id'}
              info={
                profileData.data.profile.customer_id != null
                  ? profileData.data.profile.customer_id
                  : ''
              }
            />
            <InfoBar
              title={'Full Name'}
              info={
                profileData.data.profile.name
                  ? profileData.data.profile.name
                  : ''
              }
            />
            <InfoBar
              title={'Mobile Number'}
              info={
                profileData.data.profile.mobile_no
                  ? profileData.data.profile.mobile_no
                  : ''
              }
            />
            <InfoBar
              title={'Email'}
              info={
                profileData.data.profile.email
                  ? profileData.data.profile.email
                  : ''
              }
            />
          </ScrollView>
        </View>
      )}
      <View style={styles.iconContainerStyle}>
        <FaEdit size={30} color="white" onClick={onEditPress} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  viewStyle: {
    height: HEIGHT,
  },
  infoViewStyle: {
    marginLeft: 30,
    marginTop: 10,
    height: 70,
  },
  infoTextHeaderStyle: {
    fontWeight: 'bold',
    color: 'white',
    fontFamily: 'Source Sans Pro, sans-serif',
  },
  infoTextStyle: {
    fontSize: 12,
    fontStyle: 'italic',
    color: 'grey',
    fontFamily: 'Source Sans Pro, sans-serif',
    fontWeight: 'normal',
  },
  textViewStyle: {
    marginTop: 12,
  },
  iconContainerStyle: {
    position: 'absolute',
    backgroundColor: '#1a191f',
    right: 30,
    bottom: 30,
    borderRadius: 30,
  },
  mainViewStyle: {
    backgroundColor: 'black',
    height: 200,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 0,
  },
  cardContainerStyle: {
    borderRadius: 10,
    backgroundColor: '#1c2940',
    borderWidth: 0,
    width: WIDTH < 720 ? WIDTH * 0.9 : WIDTH / 2,
  },
  indicatorViewStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1
  },
  scrollViewContainerStyle: {
    alignItems: 'center'
  },
  scrollViewStyle: {
    backgroundColor: '#1a191f',
  },
});
